"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "player-tag-discount" };
const _hoisted_2 = { class: "megacredits-container" };
const _hoisted_3 = { class: "megacredits" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", _hoisted_3, "-" + (0, vue_1.toDisplayString)(_ctx.amount), 1)
        ])
    ]));
}
